import React from "react";

// Renders a body field that mixes plain strings with { t, href } link segments.
// A plain string is passed straight through.
const RichText = ({ value }) => {
  const parts = Array.isArray(value) ? value : [value];

  return (
    <>
      {parts.map((part, index) =>
        typeof part === "string" ? (
          <React.Fragment key={index}>{part}</React.Fragment>
        ) : (
          <a
            key={index}
            className="inline-link"
            href={part.href}
            target="_blank"
            rel="noreferrer"
          >
            {part.t}
          </a>
        )
      )}
    </>
  );
};

export default RichText;
